"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var tournament_components_1 = require("@l2p/tournament-components");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Content = function (_a) {
    var id = _a.id, title = _a.title, description = _a.description, endDate = _a.endDate, me = _a.me, isFinished = _a.isFinished;
    var t = (0, next_intl_1.useTranslations)('translation');
    var isUserParticipate = (0, react_1.useMemo)(function () {
        return !!me;
    }, [me]);
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var _b = (0, swr_hooks_1.useJoinTournament)(), joinTournament = _b.joinTournament, isSubmitting = _b.isSubmitting;
    var signUpNavigate = (0, apps_shared_1.useOpenSignUp)();
    var participate = (0, react_1.useCallback)(function (id) {
        if (!isAuth)
            return signUpNavigate();
        if (id)
            joinTournament({ id: id });
    }, [joinTournament, signUpNavigate, isAuth]);
    if (isFinished)
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.firstTitle }, t('tournamentIsFinished')))));
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.firstTitle }, t('tournaments')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, title),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, description),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.participateContainer }, !isUserParticipate ? (react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", width: "100%", maxWidth: "100%", className: "participate", height: "60px", onClick: function () {
                    participate(id);
                }, loading: isSubmitting }, t('joinNow'))) : (react_1.default.createElement(tournament_components_1.YouParticipate, null))),
            endDate ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.timerWrapper },
                react_1.default.createElement(ui_components_1.Timer, { endDate: String(new Date(endDate)), title: "".concat(t('tournamentWillFinish')) }))) : null)));
};
exports.default = Content;
